import { hiddenWidgets } from '../components/cart';
import { cleanInputs, restoreFormMessage } from '../components/plus-photo';
import { closeAll } from './accordion';
import { $Q, $Qll } from './query-selector';

/**
 *
 * @param {String} id - ID from node manipulate
 * @param {Boolean} active - If modal active
 * @param {HTMLElement} node - Node to manipulate
 */
export const overlayActions = (id, active, node, noScroll, cb) => {
  const idOverlay = `overlay--${id}`;
  const parent = node.parentNode;

  if (!active) {
    // eslint-disable-next-line no-undef
    const overlay = document.createElement('div');

    overlay.setAttribute('id', idOverlay);
    overlay.classList.add('overlay');

    parent.insertBefore(overlay, node);
    // eslint-disable-next-line no-use-before-define
    toggleDataActive(`#${idOverlay}`, `#${id}`, {
      overlay: true,
      blockScroll: noScroll,
      cb: cb
    });
  } else {
    parent.removeChild($Q(`#${idOverlay}`));
  }
};

/**
 * To validate state in dataset node
 */
export const isActive = ({ active }) => active === 'true';

/**
 * Data Toggle
 *
 * @param {HTMLElement} node - Node to manipulate
 * @param {Boolean} overlay - if used to a overlay
 */
export function dataToggle(node, overlay, noScroll, cb) {
  const { dataset, id } = node;
  const active = isActive(dataset);
  let action = false;

  if (active) {
    dataset.active = 'false';
    action = false;
  } else {
    dataset.active = 'true';
    action = true;
  }

  noScroll && blockScroll(action);

  // eslint-disable-next-line no-unused-expressions
  overlay && overlayActions(id, active, node, noScroll, cb);

  return action;
}

export const blockScroll = (state) => {
  if (state) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'initial';
  }
};

const closeHeaderMenu = () => {
  const menuHeaderMobile = $Qll('#nav-list-movil-js .button-dropdown-js');

  if (!menuHeaderMobile.length) return;

  menuHeaderMobile.forEach((item) => {
    if (item.dataset.active === 'true') item.dataset.active = false;
  });
};

/**
 * Data Active toggle
 *
 * @param {String} control - ID button control
 * @param {String} node - ID modal
 * @param {Object} config - Object with overlay, closeSelector, blockScroll
 */
export const toggleDataActive = (control, node, config = {}) => {
  if (!$Q(control)) return;
  const { overlay, closeSelector, blockScroll: noScroll, type = null, cb } = config;

  $Q(control).addEventListener('click', () => {
    const status = dataToggle($Q(node), overlay, noScroll, cb);

    if (type === 'side-cart') {
      hiddenWidgets(status);
    }

    if (type === 'header-lang') {
      closeHeaderMenu();
    }

    if (type === 'plus-photo' && node === '#js-plus-photo-modal') {
      cleanInputs($Qll('#js-plus-photo-form input'), $Q('#js-plus-photo-form button[type="submit"]'))
      restoreFormMessage()
      restoreFormMessage(true)
    }

    if (cb) cb(status)
  });

  // eslint-disable-next-line no-unused-expressions
  closeSelector &&
    $Q(closeSelector).addEventListener('click', () => {
      const status = dataToggle($Q(node), overlay, noScroll, cb);

      if (type === 'side-cart') {
        hiddenWidgets(status);
      }

      if (type === 'plus-photo' && !status) {
        cleanInputs($Qll('#js-plus-photo-form input'), $Q('#js-plus-photo-form button[type="submit"]'))
        restoreFormMessage()
        restoreFormMessage(true)
      }

      if (cb) cb(status)
    });
};
